var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"nav-button",attrs:{"id":"back_button","type":"button"},on:{"click":_vm.navigatePrev}},[_vm._v("\n  "+_vm._s(_vm.$t('components.brazil_back_button.text'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }